import { useState } from 'react';
import { Layout, CtaForm } from '../../components';
import { CheckboxFeature, ResourceIcon1, ResourceIcon2, ResourceIcon3, ResourceIcon4 } from '../../components/Svg';
import { AGREEMENT_POLICY_LINK, QUESTIONNAIRE_INTEREST } from '../../constants';
import { openNotification, validateEmail } from '../../utils';
import {
	thailandFlag,
	indiaFlag,
	malaysiaFlag,
	southAfricaFlag,
	sriLankaFlag,
	brazilFlag,
	dubaiFlag,
	philippinesFlag,
} from '../../utils/images';

export default function LocalPartner() {
	return (
		<Layout pageName="Local Partner">
			<div className="resource-page resource-page--partner">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Become a FacilityBot Local Partner</h1>

							<h2 className="heading__desc">
								Let your clients experience the power of Smart Facilities Management automation using FacilityBot
							</h2>
						</div>
					</div>
				</section>

				<section className="instructions">
					<div className="container instructions__wrapper">
						<div className="instructions__left-side">
							<h3 className="instructions__heading">Who's a good fit to be a FacilityBot Local Partner?</h3>
							<div className="instructions__desc">
								FacilityBot Local Partners are agencies, resellers, distributors, consultants and system integrators.
								They are passionate about automating Facilities Management processes for their clients.
							</div>
						</div>

						<div className="instructions__right-side">
							<div className="instructions__question-title">Do these sound like you?</div>

							<Instructions />
						</div>
					</div>
				</section>

				<section className="benefits">
					<div className="container benefits__wrapper">
						<h2 className="benefits__heading">What do you get as a partner?</h2>

						<Benefits />
					</div>
				</section>

				<section className="marketing">
					<div className="container">
						<div className="marketing__form">
							<div className="mail__form">
								<a className="mail__form-btn" href={QUESTIONNAIRE_INTEREST} target="_blank" rel="noreferrer">
									Complete this questionnaire to indicate your interest
								</a>
							</div>
						</div>

						<div className="marketing__policy">
							See our{' '}
							<a href={AGREEMENT_POLICY_LINK} target="_blank" rel="noreferrer">
								Local Partner Agreement
							</a>
						</div>
					</div>
				</section>

				<section className="partners">
					<div className="container partners__wrapper">
						<h2 className="partners__heading">Local Partners</h2>

						<Partners />
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}

const Instructions = () => {
	const instructions = [
		'Do you already have clients who may benefit from better Facilities Management processes?',
		'Are you looking for a platform that is highly configurable, easily deployable and integratable?',
		'Are you looking to deploy Smart Facilities Management, Smart Buildings or Smart City solutions?',
	];

	return (
		<ul className="instructions__question-list">
			{instructions.map((item, index) => (
				<li className="instructions__question-item" key={index}>
					<div className="item__icon">
						<CheckboxFeature />
					</div>
					<span className="item__text">{item}</span>
				</li>
			))}
		</ul>
	);
};

const Benefits = () => {
	const benefits = [
		{
			icon: <ResourceIcon1 />,
			title: 'Commission or Discount Opportunities',
			desc: 'Choose whether you want to resell or bill your clients directly',
		},
		{
			icon: <ResourceIcon2 />,
			title: 'Sandbox Account',
			desc: 'A free enterprise account to demo to potential clients and leads',
		},
		{
			icon: <ResourceIcon3 />,
			title: 'Product Roadmap Updates',
			desc: 'Early access to information about upcoming features',
		},
		{
			icon: <ResourceIcon4 />,
			title: 'Dedicated Training',
			desc: 'We will provide dedicated training resources to ensure you are very familiar with FacilityBot',
		},
	];

	return (
		<div className="benefits__list">
			{benefits.map((item, index) => (
				<div className="benefits__item" key={index}>
					<div className="benefits__icon">{item.icon}</div>
					<div className="benefits__content">
						<h5 className="benefits__title">{item.title}</h5>
						<div className="benefits__desc">{item.desc}</div>
					</div>
				</div>
			))}
		</div>
	);
};

const Partners = () => {
	const partners = [
		{
			image: thailandFlag,
			title: 'Thailand',
			website: 'http://mtr.co.th',
			contact: 'Yongyut Luansritisakul',
			email: 'yongyut@mtr.co.th',
		},
		{
			image: indiaFlag,
			title: 'India',
			website: 'https://www.nxsg.in',
			contact: 'Ashik Mohanty',
			email: 'ashik.mohanty@nxsg.in',
		},
		{
			image: malaysiaFlag,
			title: 'Malaysia',
			website: 'https://www.avancerfm.com.my',
			contact: 'Mohd MAZHAR Mohd Marzuki, cFMM',
			email: 'avancerfm@gmail.com',
		},
		{
			image: southAfricaFlag,
			title: 'South Africa',
			website: 'https://www.imvokoqa.co.za',
			contact: 'Sandile Zondi',
			email: 'sandile@imvokoqa.com',
		},
		{
			image: sriLankaFlag,
			title: 'Sri Lanka',
			website: 'https://www.linkedin.com/company/cspaceylon',
			contact: 'Director Development - CORPORATE SERVICES PROFESSIONALS ASSOCIATION OF CEYLON',
			email: 'membership.cspaceylon@outlook.com',
		},
		{
			image: brazilFlag,
			title: 'Brazil',
			website: 'https://core-wpe.com.br',
			contact: 'Walter Palacio',
			email: 'walter.palacio@core-wpe.com.br',
		},
		{
			image: dubaiFlag,
			title: 'Dubai',
			website: 'https://www.knowitallit.com',
			contact: 'Shadab Khan',
			email: 'info@knowitallit.com',
		},
		{
			image: philippinesFlag,
			title: 'Philippines',
			website: 'https://www.asticom.com.ph',
			contact: 'Alex Javier',
			email: 'ajjavier@absi.ph',
		},
	];

	return (
		<div className="partners__list">
			{partners.map((item, index) => (
				<div className="partners__item" key={index}>
					<div className="partners__icon">
						<img src={item.image} alt="Country Flag" />
					</div>
					<div className="partners__content">
						<h5 className="partners__title">{item.title}</h5>
						<div className="partners__desc">
							Website:{' '}
							<a href={item.website} target="_blank" rel="noreferrer">
								{item.website}
							</a>
						</div>
						<div className="partners__desc">Contact: {item.contact}</div>
						<div className="partners__desc">
							Email: <a href={`mailto:${item.email}`}>{item.email}</a>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};
